import React, { useEffect, useMemo, useRef } from 'react'
import Loading from '../ui/Loading';
import { useMasterData } from '../../hooks/api/useMasterData';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedOptionChapelName, setSelectedOptionChapel } from '../../features/order/orderSlice';
import { AvailableChapels } from '../../types/chapel';

export default function ChapelTabs() {
    
    const selectedOptionChapelName = useSelector(selectSelectedOptionChapelName);
    const dispatch = useDispatch()
    const {  refetchOrders, chapelsAvailable, isErrorChapelsAvailable, isLoadingChapelsAvailable, isSuccessChapelsAvailable } = useMasterData() 

    const formatChapels = useMemo<AvailableChapels[]>(() =>
        chapelsAvailable.map(({ chapelID, chapelName }) => ({
            chapelID,
            chapelName,
        })), [chapelsAvailable]
    );

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, []);
        
    const scrollRef = useRef<HTMLDivElement>(null);
    let isDown = false;
    let startX: number;
    let scrollLeft: number;
        
    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        isDown = true;
        startX = e.pageX - (scrollRef.current?.offsetLeft || 0);
        scrollLeft = scrollRef.current?.scrollLeft || 0;
    };
        
    const handleMouseLeave = () => {
        isDown = false;
    };
        
    const handleMouseUp = () => {
        isDown = false;
    };
        
    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - (scrollRef.current?.offsetLeft || 0);
        const walk = (x - startX) * 1; // scroll speed multiplier
        if (scrollRef.current) {
        scrollRef.current.scrollLeft = scrollLeft - walk;
        }
    };


    return (
        <div className='space-x-3 justify-center items-center p-2'>
            <div 
                ref={scrollRef}
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
                className='overflow-x-auto flex scrollbar-hide'
            >   
                { isLoadingChapelsAvailable && (
                    <div className='w-full items-center justify-center'>
                        <Loading setH={'h-[20px]'}/>
                    </div>
                )}
                { isErrorChapelsAvailable && (
                    <div className='w-full items-center justify-center'>
                        <p>Error. Please reload the page</p>
                    </div>
                )}
                { isSuccessChapelsAvailable && (
                    <>
                        <button
                            key="all"
                            className={`flex-shrink-0 px-4 py-1 text-sm font-semibold capitalize transition-all duration-200 
                                ${ selectedOptionChapelName === 'All'
                                        ? "border-b-2 border-orange-600 text-orange-600 font-medium"
                                        : "border-b-2 border-transparent text-black hover:border-gray-300"
                                }`}
                            onClick={() => {
                                dispatch(setSelectedOptionChapel({ chapelName: 'All', chapelID: 0 }))
                                refetchOrders();
                            }}
                        >
                            All
                        </button>
                        {formatChapels.map((chapel) => (
                            <button 
                                key={chapel.chapelID}
                                className={`flex-shrink-0 px-4 py-1 text-sm font-semibold capitalize transition-all duration-200 
                                    ${
                                    selectedOptionChapelName === chapel.chapelName
                                        ? "border-b-2 border-orange-600 text-orange-600 font-medium"
                                        : "border-b-2 border-transparent text-black hover:border-gray-300"
                                    }`}
                                onClick={() => {
                                    dispatch(setSelectedOptionChapel(chapel))
                                    refetchOrders()
                                }}
                            >
                                {chapel.chapelName}
                            </button>
                        ))}
                    </>
                )}
            </div>
        </div>
    )
}
